import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/messaging/constants';

import { messagingQueryKeys } from './queryKeys';

export const useMessageThreadsQuery = (search: string) => {
  const query = useInfiniteQuery({
    queryKey: messagingQueryKeys.threadList({ search }),
    initialPageParam: undefined as string | undefined,
    queryFn: async ({ pageParam, signal }) => {
      const { data } = await fetchClient.GET(endpoints.threads, {
        params: {
          query: { search: search || undefined, cursor: pageParam, limit: 25 },
        },
        signal,
      });
      return data;
    },
    getNextPageParam: (lastPage) => lastPage?.nextCursor ?? undefined,
  });

  return {
    ...query,
    threads: query.data?.pages.flatMap((page) => page?.items ?? []) ?? [],
  };
};
